module.exports = __webpack_public_path__ + "img/portrait-001.f3b31849.jpg";